import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rmt-biller-header',
  templateUrl: 'rmt-biller-header.html'
})
export class RmtBillerHeaderComponent {
  @Input()  placeHolderText: string = "";
  @Input() image: string = "";
  @Input() titleFloatingText: string = "";
  @Input() title: string = "";
  @Input() canShowChevron: boolean = true;
  @Input() canShowPlaceHolder: boolean = true;
  @Input() canShowBackground: boolean = true;
  @Output() onHeadeSelected = new EventEmitter();
  constructor() {
  }
  onSelected(){
    if(this.onHeadeSelected){
      this.onHeadeSelected.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-biller-header/rmt-biller-header.ts